import React from "react";
import { useBundleContext } from "./BundleContext";
import { PriceDisplay } from "@/features/product/PriceDisplay";
import { Badge } from "@/components/Badge";
import { calculateBundleValue, cn } from "@/helpers/utils";
import { DroppsProduct, productSelect } from "@/store";
import { getEffectiveSubscriptionDiscountPercent } from "@/helpers/constants";

type BundlePriceProps = {
  isSubscription: boolean;
  className?: string;
  products: DroppsProduct[];
};

export const BundlePrice = ({
  isSubscription,
  className,
  products,
}: BundlePriceProps) => {
  const { bundle } = useBundleContext();
  const { retailValue, subscriptionRetailValue } = calculateBundleValue(
    products.map(productSelect.defaultVariant)
  );
  const effectiveDiscountPercent = getEffectiveSubscriptionDiscountPercent(
    bundle.discountPercent,
    { isBundle: true }
  );
  const discountPrice = (
    isSubscription ? subscriptionRetailValue : retailValue
  ).mul((100 - effectiveDiscountPercent) / 100);
  return (
    <div
      className={cn(
        "flex flex-wrap items-end justify-between gap-2",
        className
      )}
    >
      <div>
        <PriceDisplay
          standardPrice={retailValue}
          discountPrice={discountPrice}
          showDiscountPrice
          size="lg"
          alignment="left"
        />
        <p>
          You save{" "}
          {(() => {
            const percent = getEffectiveSubscriptionDiscountPercent(
              bundle.discountPercent,
              { isBundle: true }
            );
            const savings = retailValue.mul(percent / 100);
            return savings.format();
          })()}
        </p>
      </div>
      <div className="flex flex-col items-end space-y-1">
        <Badge className="flex-shrink" color="green" size="sm" bordered pill>
          <div>
            <span className="font-bold">
              {getEffectiveSubscriptionDiscountPercent(bundle.discountPercent, {
                isBundle: true,
              })}
              %
            </span>{" "}
            <span>discount</span>
          </div>
        </Badge>
        {isSubscription && (
          <div className="relative">
            <Badge color="primary" size="sm" bordered pill>
              <div className="absolute -top-2.5 right-0 flex h-4 w-4 items-center justify-center rounded-full border border-solid border-gray-900 bg-white text-gray-900">
                +
              </div>
              <div>
                <span className="font-bold">25%</span>{" "}
                <span>off subscriptions</span>
              </div>
            </Badge>
          </div>
        )}
      </div>
    </div>
  );
};
